import { app } from '../../../app';

app.factory('SharedAccountsService', SharedAccountsService);

/** @ngInject */
function SharedAccountsService($resource) {
    
    
    return $resource('app/rest/admin/company/:companyId/corporateserviceaccount', {
        companyId : '@companyId'
    }, {
        'createCompanyServiceAccounts' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:publicServiceId',
            params : {
                companyId : '@companyId',
                publicServiceId: '@publicServiceId'
            }
        },
        'updateCompanyServiceAccounts' : {
            method : 'PUT',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:publicServiceId',
            params : {
                companyId : '@companyId',
                publicServiceId: '@publicServiceId'
            }
        },
        'convertCompanyServiceAccountToAuth' : {
            method : 'PUT',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:publicServiceId/convert?to=authenticator',
            params : {
                companyId : '@companyId',
                publicServiceId: '@publicServiceId'
            }
        },
        'convertCompanyServiceAccountToPass' : {
            method : 'PUT',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:publicServiceId/convert?to=passwordManager',
            params : {
                companyId : '@companyId',
                publicServiceId: '@publicServiceId'
            }
        },
        'getAllByCompany' : {
            method : 'GET',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount',
            isArray : true,
            params : {
                companyId : '@companyId'
            }
        },
        'getAllByCompanyAndPublicService' : {
            method : 'GET',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:publicServiceId',
            isArray : true,
            params : {
                companyId : '@companyId',
                publicServiceId: '@publicServiceId'
            }
        },
        'getOneById' : {
            method : 'GET',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/item/:id',
            isArray : false,
            params : {
                companyId : '@companyId',
                id: '@id'
            }
        },
        'deleteCompanyServiceAccounts' : {
            method : 'DELETE',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:id',
            params : {
                id : '@id',
                companyId : '@companyId'
            }
        },
		'deleteBulkCompanyServiceAccounts' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/?action=delete',
            params : {
                companyId : '@companyId'
            }
        },
		'shareServiceAccountWithLabels':{
			method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/share/labels',
			params : {
                companyId : '@companyId',
                id : '@id'
            }
		},
		'unshareServiceAccountWithLabels':{
			method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/unshare/labels',
			params : {
                companyId : '@companyId',
                id : '@id'
            }
		},
		'shareServiceAccountsWithLabels':{
			method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/share/labels',
			params : {
                companyId : '@companyId'
            }
		},
		
		'updateAndShareServiceAccountsWithLabels':{
			method : 'PUT',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/share/labels?showPassword=:showPassword&showOtp=:showOtp&showNote=:showNote',
			params : {
                companyId : '@companyId',
                showPassword: '@showPassword',
                showOtp: '@showOtp',
                showNote: '@showNote'
            }
		},
        'shareCompanyServiceAccounts' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/share/:saaspassId',
            params : {
                companyId : '@companyId',
                id : '@id',
                saaspassId : 'saaspassId'
            }
        },
        'unshareCompanyServiceAccounts' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/unshare/:saaspassId',
            params : {
                companyId : '@companyId',
                id : '@id',
                saaspassId : 'saaspassId'
            }
        },
        'getSaaspassUsersByCorporateServiceAccountId' : {
            method : 'GET',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/users/:id',
            params : {
                companyId : '@companyId',
                id : '@id'
            }
        },
        'importCompanyServiceAccounts' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/import',
            isArray : true,
            params : {
                companyId: '@companyId',
                showOtp: '@showOtp',
                showPassword: '@showPassword',
            }
        },
        'importCompanyServiceAccountsFromCsv' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/import/csv/:fileType',
            isArray : false,
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined},
            params : {
                companyId: '@companyId',
                type: '@fileType'
            }
        },
        'unshareSelectedCompanyServiceAccounts' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/unshare/selected',
            params : {
                companyId : '@companyId',
                id : '@id'
            }
        },
        'shareCompanyServiceAccountsWithGroup' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/sharegroup/:groupId',
            params : {
                companyId : '@companyId',
                id : '@id',
                groupId : 'groupId'
            }
        },
        'unshareCompanyServiceAccountsWithGroup' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/unsharegroup/:groupId',
            params : {
                companyId : '@companyId',
                id : '@id',
                groupId : 'groupId'
            }
        },
        
        'getAllCompanyNotes':{
			method:'GET',
			isArray : true,
			url:'app/rest/admin/company/:companyId/corporatenote',
			params:{
				companyId: '@companyId'
			}
		},
		'getNote':{
			method:'GET',
			url:'app/rest/admin/company/:companyId/corporatenote/:id',
			params:{
				companyId: '@companyId',
				id: '@id'
			}
		},
		'createNote':{
			method:'POST',
			url:'app/rest/admin/company/:companyId/corporatenote',
			params:{
				companyId: '@companyId'
			}
		},
		'updateNote':{
			method:'PUT',
			url:'app/rest/admin/company/:companyId/corporatenote/:id',
			params:{
				companyId: '@companyId',
				id: '@id'
			}
		},
		'deleteNote': {
			method: 'DELETE',
			url:'app/rest/admin/company/:companyId/corporatenote/:id',
			params:{
				companyId: '@companyId',
				id: '@id'
			},
		},
		'getAllCompanyNotesUsers':{
			method:'GET',
			isArray : true,
			url:'app/rest/admin/company/:companyId/corporatenote/:id/users',
			params:{
				companyId: '@companyId',
				id: '@id'
				}
		},
		'shareNoteWithLabels':{
			method:'POST',
			url:'app/rest/admin/company/:companyId/corporatenote/:id/users/labels',
			params:{
				companyId: '@companyId',
				id: '@id'
				}
		},
		'unshareNoteWithLabels':{
			method:'POST',
			url:'app/rest/admin/company/:companyId/corporatenote/:id/users/unshare/labels',
			params:{
				companyId: '@companyId',
				id: '@id'
				}
		},
		'shareNoteWithSaaspassUser':{
			method:'POST',
			url:'app/rest/admin/company/:companyId/corporatenote/:id/share/:saaspassId',
			params:{
				companyId: '@companyId',
				id: '@id',
				saaspassId:'@saaspassId'
				}
		},
		'unshareUserNote' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporatenote/:id/unshare/:saaspassId',
            params : {
                companyId : '@companyId',
                id : '@id',
                saaspassId : 'saaspassId'
            }
        },
        'unshareNoteWithUsers' :{
			  method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporatenote/:id/unshare/selected',
            params : {
                companyId : '@companyId',
                id : '@id'
            }
		},
		'getAllSharedReportByCompany' : {
            method : 'GET',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/report',
            isArray : true,
            params : {
                companyId : '@companyId'
            }
        },
        'getDeletedByCompany' : {
            method : 'GET',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/report/deleted',
            isArray : true,
            params : {
                companyId : '@companyId'
            }
        }, 
        'exportCompanyServiceAccounts' : {
            method : 'POST',
            url : 'app/rest/admin/company/:companyId/corporateserviceaccount/export/csv',
            params : {
                companyId : '@companyId'
            },
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/sharing-center.service.js